import React from "react";
import Logo from '../assets/svg/logo.svg';

export default function UserPolicy() {
  return (
    <>

      <a href="/" className="logo" style={{ margin: 20, top:10, position:'fixed' }}>
        <img src={Logo} alt="Logo" />
      </a>
      <div className="user-policy-content" style={{ maxWidth: 900, margin: "0 auto", padding: 24 }}>
        <h1 style={{ textAlign: "center", marginBottom: 32 }}>ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ</h1>
        <p><b>Дата вступления в силу:</b> [дата]</p>
        <p>
          Настоящее Пользовательское соглашение, размещенное по ссылке [ссылка]
          (далее – «Соглашение») регулирует отношения между ООО «Жива Технологии»,
          ОГРН: 1257700121800, ИНН: 9723250048, юридический адрес: 109390, город
          Москва, ул. Люблинская, д. 47, помещ. 2/н, именуемым в дальнейшем «Владелец
          сайта», и любым физическим лицом, использующим сайт Jiva, который размещен
          в сети Интернет по адресу <a href="https://jivatech.ru/" target="_blank"
                                       rel="noopener noreferrer">https://jivatech.ru/</a>.
        </p>
        <p>
          Использование Сайта, включая любые его функции, означает согласие
          Пользователя с условиями Соглашения. Если Пользователь не согласен с условия
          Соглашения и не готов их принять, он обязан воздержаться от использования
          Сайта.
        </p>

        <h2>1. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ</h2>
        <p>
          В целях единого понимания содержания Соглашения, если из контекста прямо
          не следует иное, нижеприведенные термины будут иметь следующие значения:
        </p>
        <ul>
          <li>
            <b>Сайт</b> – совокупность данных и иной информации под названием
            «Jiva», доступные для просмотра в сети Интернет по адресу <a href="https://jivatech.ru/" target="_blank"
                                                                         rel="noopener noreferrer">https://jivatech.ru/</a> и
            его
            поддоменах.
          </li>
          <li>
            <b>Владелец сайта</b> – Общество с ограниченной ответственностью «Жива
            Технологии» (ОГРН: 1257700121800, ИНН: 9723250048, юридический адрес:
            109390, город Москва, ул. Люблинская, д. 47, помещ. 2/н), являющееся владельцем
            Сайта.
          </li>
          <li>
            <b>Пользователь</b> – физическое лицо, достигшее возраста 14 лет,
            использующее Сайт в соответствии с Соглашением.
          </li>
          <li>
            <b>Приложение</b> – программное обеспечение (программа для ЭВМ) под
            названием «Jiva», разработанное Владельцем сайта, предназначенное для работы
            на мобильных устройствах, предназначенное для контроля питания, расчета
            калорий, белков, жиров и углеводов (БЖУ), корректировки нормы питания,
            предоставления рекомендаций по физическим нагрузкам. Функциональный объем
            Приложения не является исчерпывающим и может быть изменен в последующих
            обновлениях.
          </li>
        </ul>

        <h2>2. ПРЕДМЕТ СОГЛАШЕНИЯ</h2>
        <p>
          2.1. Владелец сайта предоставляет Пользователю на безвозмездной
          основе возможность использования Сайта на условиях Соглашения.
        </p>
        <p>
          2.2. Использование Сайта допускается для целей: (1) ознакомления
          Пользователя с размещенной на нем информацией; (2) возможности перехода в
          аккаунты в социальных сетях Владельца сайта; (3) перехода по ссылках в магазины
          приложений «Ru Store», «App Store» и «Google Play» на соответствующие страницы
          загрузки Приложения.
        </p>
        <p>
          2.3. Пользователь обязан воздерживаться от использования Сайта в целях
          и способами, не предусмотренными Соглашением, а также функциональным
          назначением самого Сайта. В частности, не допускается использование Сайта, в
          том числе, его отдельных элементов или составных частей, за пределами
          предусмотренных пунктом 2.2. Соглашения способов.
        </p>
        <p>
          2.4. Пользователь должен воздерживаться от действий, направленные на
          нарушение нормальной работы Сайта (декомпиляция, модификация,
          распространение, в том числе путем незаконного копирования, использование
          вредоносных программ и т.д.).
        </p>
        <p>
          2.5. Пользователь, используя Сайт, обязан не нарушать интеллектуальные
          права третьих лиц или самого Владельца сайта.
        </p>
        <p>
          2.6. Владелец сайта принимает все необходимые меры по защите
          персональных данных Пользователей в соответствии с применимым
          законодательством РФ, а также Политикой конфиденциальности Сайта,
          размещенной на Сайте по адресу: [ссылка на политику конфиденциальности],
          которая является неотъемлемой частью настоящего Соглашения.
        </p>

        <h2>3. ОТВЕТСТВЕННОСТЬ</h2>
        <p>
          3.1. Владелец сайта предоставляет Сайт «как есть» и «по мере
          доступности». Владелец сайта не предоставляет никаких явно выраженных или
          подразумеваемых гарантий, что Сайт будет работать бесперебойно, безошибочно,
          соответствовать ожиданиям Пользователя, и что функциональные возможности
          Сайта смогут быть применимы для конкретной цели Пользователя.
        </p>
        <p>
          3.2. Функциональные возможности Сайта могут дополняться, изменяться
          или прекращаться в любой момент без предварительного уведомления
          Пользователя.
        </p>
        <p>
          3.3. Если при использовании Сайта будут обнаружены ошибки, Владелец
          сайта предпримет необходимые меры для их исправления в максимально короткие
          сроки. Стороны соглашаются, что точное определение срока устранения ошибки не
          может быть установлено, так как Сайт тесно взаимодействует с другими
          программами для ЭВМ сторонних лицензиаров, операционными системами и
          аппаратными ресурсами устройства Пользователя и работоспособность, и время
          устранения проблем в полной мере не зависят только от Владельца сайта.
        </p>
        <p>
          3.4. Владелец сайта не несет ответственности за любые убытки,
          возникшие у Пользователя в результате использования или невозможности
          использования Сайта, за исключением случаев, предусмотренных
          законодательством РФ.
        </p>
        <p>
          3.5. Владелец сайта не предоставляет медицинских услуг и не дает
          медицинских рекомендаций. Информация, представленная на Сайте, носит
          исключительно информационный характер и не может заменить консультацию
          врача. Пользователь самостоятельно несет ответственность за свое здоровье и за
          любые решения, принимаемые им на основе информации, полученной на Сайте.
        </p>
        <p>
          3.6. Владелец сайта не несет ответственности за отсутствие у
          Пользователя доступа в Интернет, за качество услуг провайдеров связи сети
          Интернет, с которыми Пользователем заключены соглашения о предоставлении
          услуг по доступу к сети Интернет, за любые действия или бездействия третьих лиц,
          предоставляющих Пользователю услуги, программное обеспечение или
          оборудование, за поломки устройства Пользователя во время использования
          Сайта, за перерывы, сбои и иные неполадки Сайта и вызванную ими потерю
          информации.
        </p>
        <p>
          3.7. В случае нарушения исключительных прав на интеллектуальную
          собственность Владельца сайта, Владелец сайта оставляет за собой право
          обратиться с претензией, содержащей требования о прекращении незаконного
          использования интеллектуальной собственности и выплате соответствующей
          компенсации.
        </p>

        <h2>4. РАЗРЕШЕНИЕ СПОРОВ</h2>
        <p>
          4.1. Любые разногласия, возникающие в связи с использованием Сайта,
          разрешаются между Владельцем сайта и Пользователем в претензионном
          (досудебном) порядке.
        </p>
        <p>
          4.2. Претензия должна быть направлена в письменном виде с
          использованием средств связи, обеспечивающих возможность фиксирования ее
          отправления и получения (заказной почтой, электронной почтой и т.д.).
        </p>
        <p>
          4.3. Срок ответа на досудебную претензию составляет 15 (пятнадцать)
          календарных дней с момента получения претензии одной из сторон.
        </p>
        <p>
          4.4. В случае невозможности урегулировать возникший спор в
          претензионном (досудебном) порядке, а также неполучения ответа на претензию в
          срок, предусмотренный п. 4.2 Соглашения, заинтересованная сторона вправе
          передать данный спор на рассмотрение компетентного суда по месту нахождения
          Владельца сайта.
        </p>

        <h2>5. ДЕЙСТВИЕ, ИЗМЕНЕНИЕ И РАСТОРЖЕНИЕ СОГЛАШЕНИЯ</h2>
        <p>
          5.1. Соглашение считается заключенным и приобретает силу для
          Пользователя с момента начала использования Сайта, что означает
          безоговорочное принятие Пользователем всех условий без каких-либо изъятий или
          ограничений, на условиях присоединения к условиям Соглашения.
        </p>
        <p>
          5.2. Началом использования Сайта является переход на любую страницу
          Сайта вне зависимости от факта нажатия/не нажатия на кнопку согласия с
          Соглашением, вне зависимости от даты, времени нажатия на кнопку согласия с
          Соглашением.
        </p>
        <p>
          5.3. Соглашение может быть изменено Владельцем сайта в
          одностороннем порядке. Новая редакция вступает в силу с момента ее размещения
          на Сайте, если иное не предусмотрено новой редакцией Соглашения. В случае
          несогласия с новой редакцией Соглашения, Пользователь должен
          незамедлительно прекратить использование Сайта.
        </p>

        <h2>6. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</h2>
        <p>
          6.1. Настоящее Соглашение регулируется и толкуется в соответствии с
          законодательством РФ. Вопросы, не урегулированные настоящим Соглашением,
          подлежат разрешению в соответствии с законодательством РФ.
        </p>
        <p>
          6.2. Признание отдельных положений Соглашения недействительными не
          влечет недействительность Соглашения в целом.
        </p>
        <p>
          6.3. Обращения по вопросам условий Соглашения и технической
          поддержки принимаются по электронной почте: <a href="mailto:info@jivatech.ru">info@jivatech.ru</a>.
        </p>
      </div>
    </>
  );
}
